import { render, staticRenderFns } from "./Exercises.vue?vue&type=template&id=b15c4618&"
import script from "./Exercises.vue?vue&type=script&lang=js&"
export * from "./Exercises.vue?vue&type=script&lang=js&"
import style0 from "./Exercises.vue?vue&type=style&index=0&id=b15c4618&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports